import { render } from "./InputNumberCustom.vue?vue&type=template&id=83dff3d0"
import script from "./InputNumberCustom.vue?vue&type=script&lang=js"
export * from "./InputNumberCustom.vue?vue&type=script&lang=js"

import "./InputNumberCustom.vue?vue&type=style&index=0&id=83dff3d0&scopedz=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__